import React from 'react';
import { SaveMembershipForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';
import { useParams } from 'react-router-dom';

export type SaveMembershipModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: SaveMembershipModalProps) => {
  const params = useParams();
  const personId = params.personId ?? '';
  const projectId = params.projectId ?? '';
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Save membership'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <SaveMembershipForm.FC
        personId={personId}
        projectId={projectId}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
